import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../../core/_BLComponent.jsx';
import Slider from 'react-slick';

import HiddenScroll from '../../common/_HiddenScroll.jsx';
import ModalFrame from '../../common/_ModalFrame.jsx';
import VideoContent from '../../common/_VideoContent.jsx';


export default class BDPVideoGalleryBlock extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
			activeSlide: 0
		}

		this.slickSettings = {
			dots: false,
			arrows: false,
			slidesToShow: 2,
			slidesToScroll: 2,
			infinite: false,
			beforeChange: (current, next) => this.setState({activeSlide: next}),
			responsive: [
				{
					breakpoint: 568,
					settings: {
						dots: false,
						arrows:false,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		}

		this.videos = this.props.finalists.filter(item => item.dmDesignerInfo != null && item.dmDesignerInfo.strVideoURL);
	}

	render() {
		const {classes = '', seriesContent, finalists} = this.props;
		const todayDate = blapp.config.server_time;
		const videoItems = this.videos.filter(item => item.dmDesignerInfo.udtVideoLaunchDate && item.dmDesignerInfo.udtVideoLaunchDate <= todayDate).sort((itemA, itemB) => itemA.dmDesignerInfo.udtVideoLaunchDate <= itemB.dmDesignerInfo.udtVideoLaunchDate ? -1 : 1).reverse().map((video, idx) => this.returnVideo(video, idx));

		if(videoItems.length) {
			return (
				<section className={`bdp-series-main__cross-promotion bdp-video-gallery ${classes}`}>
					{this.state.showVideoModal ? this.renderVideoModal() : null}
					<h1 className="bdp-video-gallery__title">Learn how our {seriesContent.strName} finalists got inspiration for their designs</h1>
					{videoItems.length == 1 ?
						<div className="bdp-video-gallery__video-slider">
							{videoItems}
						</div>
					:
						<React.Fragment>
							<Slider className="bdp-video-gallery__video-slider" ref={videoGallery => this.videoGallery = videoGallery} {...this.slickSettings}>
								{videoItems}
							</Slider>
							<div className={`bdp-video-gallery__pagination ${videoItems.length <= 2 ? 'bdp-video-gallery__pagination--one-page' : ''}`}>
								<ul className="slick-dots l-margin-top--null bdp-video-gallery__pagination-item bdp-video-gallery__pagination-item--large-screen">
									{this.renderPagination(videoItems.length - 1, 2)}
								</ul>
								<ul className="slick-dots l-margin-top--null bdp-video-gallery__pagination-item bdp-video-gallery__pagination-item--small-screen">
									{this.renderPagination(videoItems.length - 1, 1)}
								</ul>
								<div className="l-flex">
									<button className="bdp-model__whats-next-slider-button l-margin-right" disabled={this.state.activeSlide == 0} onClick={() => this.prevSlide()}>
										<i className="fas fa-chevron-left"/>
									</button>
									<button className="bdp-model__whats-next-slider-button bdp-video-gallery__pagination-item bdp-video-gallery__pagination-item--small-screen" disabled={this.state.activeSlide == this.videos.length - 1} onClick={() => this.nextSlide()}>
										<i className="fas fa-chevron-right"/>
									</button>
									<button className="bdp-model__whats-next-slider-button bdp-video-gallery__pagination-item bdp-video-gallery__pagination-item--large-screen" disabled={this.state.activeSlide == this.videos.length - (2 - (this.videos.length % 2 === 0 ? 0 : 1))} onClick={() => this.nextSlide()}>
										<i className="fas fa-chevron-right"/>
									</button>
								</div>
							</div>
						</React.Fragment>
					}
				</section>
			);
		}else{
			return false;
		}
	}

	renderPagination(amount, step) {
		let pagination = [];

		for(let i = 0; i <= amount; i += step) {
				pagination.push(
					<li key={i} className={this.state.activeSlide == i ? 'slick-active' : ''}>
						<button onClick={() => this.changeSlide(i)}>{i}</button>
					</li>
				);
		}

		return pagination;
	}

	returnVideo(video, idx) {
		const {strVideoURL, strVideoDuration} = video.dmDesignerInfo;

		if(video.dmDesignerInfo.dmVideoCoverImage) {
			return (
				<article key={video.idSubmission} className="adp-video-card bdp-video-card">
					<div className="adp-video-card__internal bdp-video-card__internal">
						<button className="adp-video-card__image l-cursor-pointer" onClick={() => this.toggleVideoModal(strVideoURL, video.strSubmissionName)}>
							<img src={video.dmDesignerInfo.dmVideoCoverImage.url} alt={video.strSubmissionName} className="bdp-video-card__image adp-video-card__image-item"/>
						</button>
						<div className="adp-video-card__content">
							<div className="adp-video-card__title">{video.strSubmissionName}</div>
							<div className="adp-video-card__meta">
								<button className="btn btn--link text--bold l-cursor-pointer" onClick={() => this.toggleVideoModal(strVideoURL, video.strSubmissionName)}>Watch video</button>
								<span className="adp-video-card__duration">Duration: {strVideoDuration}</span>
							</div>
						</div>
					</div>
				</article>
			);
		}
	}

	renderVideoModal() {
		const videoThumbs = this.videos.map(video => {
			return (
				<button className={`bdp-video-gallery__modal-thumb l-cursor-pointer ${this.state.videoModalTitle == video.strSubmissionName ? 'bdp-video-gallery__modal-thumb--active' : ''}`} onClick={() => this.setState({videoModalTitle: video.strSubmissionName, videoModalUrl: video.dmDesignerInfo.strVideoURL})}>
					<img src={video.dmDesignerInfo.dmVideoCoverImage.url} alt={video.strSubmissionName}/>
				</button>
			)
		});

		return (
			<ModalFrame classes="bdp-video-gallery__modal modal--large" closeFunc={() => this.toggleVideoModal()}>
				<header className="l-flex l-split l-margin-bottom">
					<h1 className="text--title text--bold">{this.state.videoModalTitle}</h1>
					<button className="text--title text--bold l-margin-left l-cursor-pointer" onClick={() => this.toggleVideoModal()}><i className="fas fa-times"/></button>
				</header>
				{this.renderVideoContent(this.state.videoModalUrl)}
				<HiddenScroll classes="bdp-video-gallery__modal-thumbnails">
					{videoThumbs}
				</HiddenScroll>
			</ModalFrame>
		);
	}

	changeSlide(slide) {
		this.setState({activeSlide: slide});

		this.videoGallery.slickGoTo(slide);
	}

	nextSlide() {
		this.videoGallery.slickNext();
	}
	prevSlide() {
		this.videoGallery.slickPrev();
	}

	toggleVideoModal(url, title) {
		this.setState({showVideoModal: !this.state.showVideoModal, videoModalUrl: url, videoModalTitle: title}, blapp.screen.toggleScroll(!this.state.showVideoModal));
	}

	renderVideoContent(url) {
		return <VideoContent classes="bdp-video-gallery__modal-video" url={url}/>
	}
}